// ErrorBoundary.js
import React, { Component } from "react";
import { toast } from "./AppToast";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Show toast notification
    toast.error("An unexpected error occurred");

    this.setState({ errorInfo });

    // Handle unhandled promise rejections
    window.addEventListener("unhandledrejection", (event) => {
      toast.error("An unexpected error occurred");
    });
  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
    });
  };

  render() {
    if (this.state.hasError) {
      // Fallback UI when an error occurs
      return (
        <div className="error-boundary-container p-4 text-center">
          <div className="card shadow">
            <div className="card-body">
              <h2 className="text-danger mb-3">
                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                Something went wrong
              </h2>
              <p className="mb-4">
                We're sorry, but an unexpected error occurred.
              </p>
              <div className="d-flex justify-content-center mb-3">
                <button
                  className="btn btn-primary me-2"
                  onClick={this.handleReset}
                >
                  Try Again
                </button>
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => window.location.reload()}
                >
                  Reload Page
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
